import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=8c9ad1bc&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "../../less/home.less?vue&type=style&index=0&id=8c9ad1bc&lang=less&scoped=true&"
import style1 from "../../less/skeleton.less?vue&type=style&index=1&id=8c9ad1bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9ad1bc",
  null
  
)

export default component.exports